module.exports = __webpack_public_path__ + "static/media/info.07ee95e7.svg";